import { render, staticRenderFns } from "./SystemConfigManagement.vue?vue&type=template&id=0ea27039&scoped=true"
import script from "./SystemConfigManagement.vue?vue&type=script&lang=js"
export * from "./SystemConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigManagement.vue?vue&type=style&index=0&id=0ea27039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea27039",
  null
  
)

export default component.exports